<div class="cr-page">
  <div class="cr-head">
    <div>
      <h1>{{ template?.displayName || 'Automatic notification' }}</h1>
      <p>An email the system sends on its own. Changes apply to the next one it sends.</p>
    </div>
    <div class="cr-row">
      <span class="cr-badge ok"><mat-icon>bolt</mat-icon>Sent automatically</span>
      <button mat-stroked-button type="button" class="cr-preview-toggle" (click)="togglePreview()" [attr.aria-pressed]="showPreview">
      <mat-icon>{{ showPreview ? 'visibility_off' : 'visibility' }}</mat-icon>{{ showPreview ? 'Hide preview' : 'Show preview' }}
    </button>
    </div>
  </div>

  <div class="cr-grid" [class.no-preview]="!showPreview">
    <form class="cr-card" [formGroup]="form" (ngSubmit)="onSave()" novalidate>
      <div class="cr-section">
        @if (template?.description) {
          <div class="cr-trigger">
            <mat-icon>notifications_active</mat-icon>
            <div><b>When it's sent</b><br>{{ template?.description }}</div>
          </div>
        }

        <mat-form-field appearance="outline" class="cr-full" subscriptSizing="dynamic">
          <mat-label>Subject</mat-label>
          <input matInput formControlName="subject" autocomplete="off" />
          <mat-error>Subject is required</mat-error>
        </mat-form-field>

        <div class="cr-field">
          <span class="cr-label">Format</span>
          <div class="cr-seg" role="group" aria-label="Format">
            <button type="button" [attr.aria-pressed]="isHtml" (click)="setHtml(true)"><mat-icon>format_paint</mat-icon>Formatted email</button>
            <button type="button" [attr.aria-pressed]="!isHtml" (click)="setHtml(false)"><mat-icon>notes</mat-icon>Plain text</button>
          </div>
        </div>

        <div class="cr-field">
          <div class="cr-label-row">
            <span class="cr-label">Message</span>
            <app-insert-variable [tokens]="template?.tokens ?? []" (pick)="insertToken($event)"></app-insert-variable>
          </div>
          @if (isHtml) {
            <app-html-editor #editor formControlName="content" [fullPage]="true"
              [invalid]="!!(form.get('content')?.invalid && form.get('content')?.touched)"></app-html-editor>
          } @else {
            <textarea #plain class="cr-plain" formControlName="content" rows="14" spellcheck="true"></textarea>
          }
          @if (form.get('content')?.hasError('required') && form.get('content')?.touched) {
            <mat-error>Message is required</mat-error>
          }
        </div>

        @if (requiredTokens.length) {
          <div class="cr-req" aria-live="polite">
            <span class="cr-label">This message must include</span>
            <div class="cr-row">
              @for (t of requiredTokens; track t) {
                @if (hasToken(t)) {
                  <span class="cr-badge ok"><mat-icon>check</mat-icon>{{ label(t) }}</span>
                } @else {
                  <span class="cr-badge bad"><mat-icon>error</mat-icon>{{ label(t) }} is missing. Add it with “Insert customer info”.</span>
                }
              }
            </div>
          </div>
        }
      </div>
      <div class="cr-section cr-foot">
        <span class="cr-sysid">System ID: {{ code }}</span>
      </div>
    </form>

    <aside class="cr-preview">
      <div class="cr-preview-head">
        <strong>Preview</strong>
        <button mat-stroked-button type="button" (click)="sendTest()" [disabled]="testing || form.invalid">
          <mat-icon>forward_to_inbox</mat-icon>{{ testing ? 'Sending…' : 'Send me a test' }}
        </button>
      </div>
      <app-email-preview [subject]="form.value.subject" [body]="form.value.content" [isHtml]="isHtml"></app-email-preview>
      <p class="cr-hint">Customer info is filled with sample data.</p>
    </aside>
  </div>

  <div class="cr-actions">
    <button mat-button type="button" (click)="goBack()"><mat-icon>close</mat-icon>Cancel</button>
    <button mat-flat-button color="primary" type="button" (click)="onSave()" [disabled]="saving || missingRequired">
      <mat-icon>save</mat-icon>{{ saving ? 'Saving…' : 'Save changes' }}
    </button>
  </div>
</div>
